<template>
  <ImageQuestion
    class="audio"
    v-bind:data="data"
  >
    <div v-show="isAudioPlaying" class="sound-icon">Играет музыка</div>

    <!-- <div
      class="audio-wrapper muted"
      v-show="isMuted"
      v-on:click="unmutePlayer"
    ></div> -->

    <audio ref="audioPlayer" v-bind:src="data.media" autoplay />
  </ImageQuestion>
</template>

<script>
// import canAutoplay from 'can-autoplay';

import * as AppSound from '../../../state/AppSound';

import ImageQuestion from './ImageQuestion.vue';

export default {
  name: 'AudioQuestion',

  components: {
    ImageQuestion,
  },

  props: {
    data: Object,
    meta: Object,
  },

  data() {
    return {
      isAudioPlaying: false,
      isMuted: !AppSound.getters.isSoundOn(),
    };
  },

  computed: {
    volumeOn() {
      return AppSound.getters.isSoundOn();
    },
  },

  beforeDestroy() {
    this.$refs.audioPlayer.removeEventListener('pause', this.audioPaused);
  },

  mounted() {
    this.$refs.audioPlayer.muted = this.isMuted;

    if (this.isMuted) {
      this.$refs.audioPlayer.autoplay = false;
    } else {
      this.isAudioPlaying = true;
    }

    // canAutoplay.audio()
    //   .then(({ result }) => {
    //     if (!result) {
    //       // set muted
    //       this.$refs.audioPlayer.muted = true;
    //       this.isMuted = true;
    //       this.isAudioPlaying = false;
    //     } else {
    //       this.isAudioPlaying = true;

    //       setTimeout(() => {
    //         this.$refs.audioPlayer.play();
    //       }, 1e3);
    //     }
    //   });

    this.$refs.audioPlayer.addEventListener('pause', this.audioPaused);
  },

  methods: {
    audioPaused(evt) {
      if (evt.type === 'pause') {
        this.isAudioPlaying = false;
      }
    },

    unmutePlayer() {
      this.isMuted = false;

      this.$refs.audioPlayer.muted = false;
      this.$refs.audioPlayer.play();

      this.isAudioPlaying = true;
    },

    mutePlayer() {
      this.isMuted = true;

      this.$refs.audioPlayer.muted = true;
      this.$refs.audioPlayer.pause();

      this.isAudioPlaying = false;
    },
  },

  watch: {
    volumeOn(val) {
      if (val) {
        this.unmutePlayer();
      } else {
        this.mutePlayer();
      }
    },
  },
};
</script>
